<template>
	<!-- 转换页面 -->
	<div class="cash_wrap">
		<!-- 顶部导航栏 -->
		<div class="red_top_bg">
			<div class="back_left" @click="$router.go(-1)"></div>
			<div class="big_tit">{{ $t('cash.withdraw') }}</div>
		</div>

		<!-- 余额卡片 -->
		<div class="balance_card">
			<!-- 转换类型切换 -->
			<div class="type_tabs">
				<div class="tab_item" :class="{ active: withdrawType === 'balance' }" @click="switchType('balance')">
					余额转换
				</div>
				<div class="tab_item" :class="{ active: withdrawType === 'points' }" @click="switchType('points')">
					积分转换
				</div>
			</div>
			<div class="balance_header">
				<span class="balance_label">{{ withdrawType === 'balance' ? '可用余额' : '可用积分' }}</span>
				<van-icon :name="eye ? 'eye' : 'closed-eye'" @click="eye = !eye" class="eye_icon" />
			</div>
			<div class="balance_amount">
				<span class="amount">{{ eye ? currentBalance : '******' }}</span>
			</div>
		</div>

		<!-- 转换信息卡片 -->
		<div class="info_card">
			<!-- 选择钱包 -->
			<div class="form_item" @click="show = true">
				<div class="item_label">{{ $t('cash.wallet') }}</div>
				<div class="item_value">
					<span>{{ bank_name }}</span>
					<van-icon name="arrow" class="arrow_icon" />
				</div>
			</div>

			<!-- 转换金额 -->
			<div class="form_item">
				<div class="item_label">{{ $t('cash.amount') }}</div>
				<div class="item_input">
					<input v-model="form.money" type="number" step="0.01"
						:placeholder="'可转换' + currentBalance + (withdrawType === 'points' ? '积分' : '')">
				</div>
			</div>

			<!-- 手续费提示 -->
			<div class="charge_tip" v-if="chargeTip">
				{{ chargeTip }}
			</div>
		</div>

		<!-- 到账时间提示 -->
		<div class="arrival_tip">
			<van-icon name="clock-o" />
			<span>{{ $t('cash.arrivalTime') }}</span>
		</div>

		<!-- 提交按钮 -->
		<div class="submit_btn" @click="write_psd = true; submitType = 1;">
			{{ $t('utils.submit') }}
		</div>

		<!-- 钱包选择弹窗 -->
		<van-action-sheet v-model="show" :description="$t('cash.chooseWallet')" close-on-click-action>
			<div class="wallet_list">
				<div class="wallet_item" v-for="item in actions" :key="item.value" @click="onSelect(item)">
					<div class="wallet_icon">
						<img v-if="item.logo" :src="item.logo" />
						<!-- <img v-else src="../images/new/icons8-silver-bars-100.png" /> -->
					</div>
					<div class="wallet_name">{{ item.name }}</div>
					<van-icon name="arrow" class="arrow_icon" />
				</div>
			</div>
		</van-action-sheet>

		<!-- 密码输入弹窗 -->
		<van-popup v-model="write_psd" round position="bottom">
			<div class="psw_box">
				<div class="psw_content">
					<div class="psw_title">{{ $t('cash.tips') }}</div>
					<van-password-input :value="psd_val" :mask="true" :focused="showKeyboard"
						@focus="showKeyboard = true" />
					<div class="psw_complete" @click="onInputComplete">{{ $t('utils.complete') }}</div>
				</div>
				<div class="keyboard_box">
					<div class="keyboard">
						<div class="key_item" v-for="i in Keyboard" :key="i.number" @click="onInput(i.number)">
							<div class="key_inner">{{ i.number }}</div>
							<div class="key_letter">{{ i.letter }}</div>
						</div>
						<div class="key_item cancel" @click="write_psd = false">
							<div class="key_inner">{{ $t('utils.cancel') }}</div>
						</div>
						<div class="key_item" @click="onInput(0)">
							<div class="key_inner">0</div>
							<div class="key_letter">abc</div>
						</div>
						<div class="key_item delete" @click="onDelete">
							<div class="key_inner">{{ $t('utils.delete') }}</div>
						</div>
					</div>
				</div>
			</div>
		</van-popup>

		<!-- 设置密码提示 -->
		<div v-if="setPwd" class="setpwd_mask">
			<div class="setpwd_box">
				<div class="setpwd_title">{{ $t('cash.setPwdFirst') }}</div>
				<div class="setpwd_btn" @click="setIniPwd">{{ $t('cash.setNow') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * 转换页面组件
 * 用户选择转换钱包，输入金额和密码完成转换操作
 */
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import { Popup, PasswordInput, NumberKeyboard, Icon, ActionSheet, Toast } from 'vant';

Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(Icon).use(ActionSheet);

export default {
	name: "cash",
	/**
	 * 组件数据
	 * @returns {Object} 数据对象
	 * @returns {Object} data - 账户数据
	 * @returns {boolean} eye - 余额是否可见
	 * @returns {boolean} show - 钱包选择弹窗是否显示
	 * @returns {boolean} write_psd - 密码输入弹窗是否显示
	 * @returns {string} psd_val - 密码值
	 * @returns {string} bank_name - 选中的钱包名称
	 * @returns {Array} actions - 钱包列表
	 * @returns {Object} form - 转换表单数据
	 * @returns {string} chargeTip - 手续费提示
	 * @returns {boolean} setPwd - 是否需要设置密码
	 * @returns {number} submitType - 提交类型（1-转换，2-设置密码）
	 */
	data() {
		return {
			data: {},
			eye: true,
			show: false,
			write_psd: false,
			showKeyboard: true,
			psd_val: '',
			bank_name: this.$t('cash.chooseWallet'),
			actions: [],
			form: {
				money: '',
				password: '',
				bank_id: 0,
			},
			charge: 0,
			type: 1,
			chargeTip: '',
			setPwd: false,
			submitType: 1,
			withdrawType: 'balance',
			points: 0,
			Keyboard: [
				{ number: 1, letter: "" },
				{ number: 2, letter: "abc" },
				{ number: 3, letter: "def" },
				{ number: 4, letter: "ghi" },
				{ number: 5, letter: "jkl" },
				{ number: 6, letter: "mno" },
				{ number: 7, letter: "pqrs" },
				{ number: 8, letter: "tuv" },
				{ number: 9, letter: "wxyz" }
			]
		};
	},
	computed: {
		currentBalance() {
			return this.withdrawType === 'balance' ? this.data.money : this.data.integral;
		}
	},
	created() {
		this.$parent.footer('user', false);
	},
	mounted() {
		this.start();
	},
	methods: {
		/**
		 * 切换转换类型
		 * @param {string} type - 转换类型 (balance/points)
		 */
		switchType(type) {
			this.withdrawType = type;
			this.form.money = '';
			this.chargeTip = '';
			// if (type === 'points' && this.points === 0) {
			// 	this.loadPointsData();
			// }
		},
		/**
		 * 加载积分数据
		 * 获取用户积分余额
		 */
		loadPointsData() {
			Fetch('/user/points_balance').then(r => {
				if (r.code === 1) {
					this.points = r.data.points || 0;
				}
			});
		},
		/**
		 * 初始化页面数据
		 * 获取账户余额和钱包列表
		 */
		start() {
			Fetch('/user/my_bank').then((r) => {
				this.data = r.data;
				this.setPwd = r.data.intPwd;
				
				// 构建钱包列表
				const bankList = r.data.bank.map(item => {
					const account = String(item.account);
					const lastFour = account.substr(-4);
					if (item.type == 4) {
						item.bank = this.$t('cash.bank');
					}
					return {
						name: `${item.bank}(****${lastFour})`,
						value: item.id,
						charge: item.charge,
						type: item.type,
						logo: item.logo
					};
				});

				// 添加新钱包选项
				bankList.push({
					name: this.$t('cash.addWallet'),
					value: 0,
					color: "#FF0000",
				});

				this.actions = bankList;
			});
		},
		/**
		 * 选择钱包
		 * @param {Object} item - 选中的钱包对象
		 */
		onSelect(item) {
			this.form.money = "";
			this.show = false;
			this.bank_name = item.name;
			this.form.bank_id = item.value;
			this.charge = item.charge || 0;
			this.type = item.type || 1;

			// 积分转换无手续费
			if (this.withdrawType === 'points') {
				this.chargeTip = "积分转换无手续费";
				this.charge = 0;
			} else if (item.charge > 0) {
				// 设置手续费提示
				if (this.type == 1) {
					this.chargeTip = this.$t('cash.charge') + ": $" + item.charge;
				} else {
					this.chargeTip = this.$t('cash.charge') + ": " + item.charge + "%";
				}
			} else {
				this.chargeTip = "";
			}

			// 添加新钱包跳转
			if (item.value == 0) {
				this.$router.push('/addcountUsdt');
			}
		},
		/**
		 * 输入密码数字
		 * @param {number} key - 输入的数字
		 */
		onInput(key) {
			this.psd_val = (this.psd_val + key).slice(0, 6);

			// 密码输入完成
			if (this.psd_val.length == 6) {
				this.write_psd = false;
				this.form.password = this.psd_val;
				if (this.submitType == 1) {
					this.submit();
				} else {
					this.setIniPwdSubmit();
				}
			}
		},
		/**
		 * 密码输入完成回调
		 */
		onInputComplete() {
			if (this.psd_val.length == 6) {
				this.write_psd = false;
				this.form.password = this.psd_val;
				if (this.submitType == 1) {
					this.submit();
				} else {
					this.setIniPwdSubmit();
				}
			}
		},
		/**
		 * 删除密码字符
		 */
		onDelete() {
			this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
		},
		/**
		 * 使用全部余额
		 */
		subAll() {
			this.form.money = this.data.money;
		},
		/**
		 * 提交转换申请
		 * 验证表单并提交
		 */
		submit() {
			this.psd_val = "";

			// 验证转换金额
			if (!this.form.money) {
				this.$toast({
					className: "toastName",
					message: this.$t('cash.withdrawalAmountEmpty')
				});
				return false;
			}
			if (this.form.money < 0) {
				this.$toast({
					className: "toastName",
					message: this.$t('cash.withdrawalAmountNotAllow')
				});
				return false;
			}
			if (parseInt(this.form.money) > parseInt(this.currentBalance)) {
				this.$toast({
					className: "toastName",
					message: this.$t('cash.withdrawalAmountHigh')
				});
				return false;
			}

			// 验证转换账户
			if (this.form.bank_id == 0 || this.form.bank_id == -1) {
				this.$toast({
					className: "toastName",
					message: this.$t('cash.withdrawalAccountEmpty')
				});
				return false;
			}

			// 验证密码
			if (!this.form.password) {
				this.$toast({
					className: "toastName",
					message: this.$t('cash.withdrawalPasswordEmpty')
				});
				return false;
			}

			// 提交转换申请
			Fetch('/user/cost_apply', {
				money: this.form.money,
				bank_id: this.form.bank_id,
				passwd: this.form.password,
				withdraw_type: this.withdrawType
			}).then(() => {
				this.$toast({
					className: "toastName",
					message: this.$t('cash.success')
				});
				this.$router.replace('/user');
			});
		},
		/**
		 * 提交设置初始密码
		 */
		setIniPwdSubmit() {
			this.psd_val = "";
			Fetch('/user/setIniPwd', {
				password: this.form.password
			}).then(() => {
				this.setPwd = false;
			});
		},
		/**
		 * 打开设置密码弹窗
		 */
		setIniPwd() {
			this.submitType = 2;
			this.write_psd = true;
		}
	}
};
</script>

<style lang="less" scoped>
/**
 * 转换页面样式
 * 采用卡片式设计，统一视觉风格
 */
.cash_wrap {
	min-height: 100vh;
	background-color: #f5f5f5;
	padding-bottom: 30px;
}

/* 顶部背景 */
.red_top_bg {
	height: 168px;
	background-image: url(../images/user/moneybag/bg.png);
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 10;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

/* 余额卡片 */
.balance_card {
	position: relative;
	margin-top: 74px;
	margin-left: 15px;
	margin-right: 15px;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
	border-radius: 12px;
	padding: 20px;
	box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
	z-index: 11;

	/* 转换类型切换 */
	.type_tabs {
		display: flex;
		background: rgba(255, 255, 255, 0.2);
		border-radius: 8px;
		padding: 3px;
		margin-bottom: 20px;

		.tab_item {
			flex: 1;
			text-align: center;
			padding: 8px 0;
			font-size: 14px;
			color: rgba(255, 255, 255, 0.8);
			cursor: pointer;
			border-radius: 6px;
			transition: all 0.3s ease;

			&.active {
				background: #fff;
				color: #ff5252;
				font-weight: 600;
			}
		}
	}

	.balance_header {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 15px;

		.balance_label {
			font-size: 14px;
			color: rgba(255, 255, 255, 0.9);
			margin-right: 8px;
		}

		.eye_icon {
			font-size: 20px;
			color: rgba(255, 255, 255, 0.8);
			cursor: pointer;
		}
	}

	.balance_amount {
		text-align: center;

		.currency {
			font-size: 20px;
			color: #fff;
			margin-right: 4px;
		}

		.amount {
			font-size: 36px;
			font-weight: bold;
			color: #fff;
			text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		}
	}
}

/* 信息卡片 */
.info_card {
	margin: 20px 15px;
	background: #fff;
	border-radius: 12px;
	padding: 5px 0;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

/* 手续费提示 */
.charge_tip {
	padding: 12px 20px;
	font-size: 13px;
	color: #ff5252;
	background: #fff8f8;
	border-top: 1px solid #f5f5f5;
	margin: 0 15px;
	border-radius: 0 0 12px 12px;
}

/* 表单项 */
.form_item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 20px;
	border-bottom: 1px solid #f5f5f5;

	&:last-child {
		border-bottom: none;
	}

	.item_label {
		font-size: 14px;
		color: #333;
		font-weight: 500;
		white-space: nowrap;
		margin-right: 15px;
	}

	.item_value {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: flex-end;

		span {
			font-size: 14px;
			color: #999;
			margin-right: 8px;
		}

		.arrow_icon {
			font-size: 16px;
			color: #ccc;
		}
	}

	.item_input {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: flex-end;

		input {
			flex: 1;
			text-align: right;
			border: none;
			outline: none;
			font-size: 16px;
			color: #333;
			background: transparent;

			&::placeholder {
				color: #ccc;
			}
		}

		.unit {
			font-size: 14px;
			color: #666;
			margin-left: 8px;
		}
	}
}

/* 到账时间提示 */
.arrival_tip {
	display: flex;
	align-items: center;
	margin: 15px 15px 0;
	padding: 12px 15px;
	background: #fff5f5;
	border-radius: 8px;
	border-left: 3px solid #ff5252;

	.van-icon {
		font-size: 16px;
		color: #ff5252;
		margin-right: 8px;
	}

	span {
		font-size: 12px;
		color: #666;
	}
}

/* 提交按钮 */
.submit_btn {
	margin: 25px 15px;
	height: 48px;
	line-height: 48px;
	text-align: center;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
	color: #fff;
	font-size: 16px;
	font-weight: 600;
	border-radius: 24px;
	box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
	cursor: pointer;
	transition: all 0.3s ease;

	&:active {
		transform: scale(0.98);
		box-shadow: 0 2px 8px rgba(255, 82, 82, 0.4);
	}
}

/* 钱包选择弹窗 */
/deep/ .van-action-sheet {
	.van-action-sheet__description {
		background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
		color: #fff;
		font-size: 14px;
		padding: 15px 20px;
		margin: 0;

		&::after {
			display: none;
		}
	}
}

.wallet_list {
	max-height: 400px;
	overflow-y: auto;
	padding: 10px 0;
}

.wallet_item {
	display: flex;
	align-items: center;
	padding: 15px 20px;
	border-bottom: 1px solid #f5f5f5;
	cursor: pointer;
	transition: background 0.2s;

	&:hover {
		background: #f9f9f9;
	}

	.wallet_icon {
		width: 36px;
		height: 36px;
		margin-right: 12px;
		border-radius: 8px;
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	.wallet_name {
		flex: 1;
		font-size: 14px;
		color: #333;
	}

	.arrow_icon {
		font-size: 16px;
		color: #ccc;
	}
}

/* 密码输入弹窗 */
.psw_box {
	background: #fff;
}

.psw_content {
	padding: 25px 20px 35px;

	.psw_title {
		font-size: 16px;
		color: #333;
		font-weight: 600;
		text-align: center;
		margin-bottom: 25px;
	}

	.van-password-input {
		margin: 0;

		.van-password-input__security {
			height: 50px;
			justify-content: space-between;

			&::after {
				display: none;
			}

			li {
				width: 46px;
				border: 2px solid #e0e0e0;
				border-radius: 8px;
				flex: unset;
				background-color: #f8f8f8;
			}
		}
	}

	.psw_complete {
		margin: 25px auto 0;
		width: 100%;
		height: 44px;
		line-height: 44px;
		text-align: center;
		background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
		color: #fff;
		font-size: 15px;
		font-weight: 600;
		border-radius: 22px;
		cursor: pointer;
	}
}

/* 键盘区域 */
.keyboard_box {
	background: #f2f3f5;
	padding: 8px 6px 12px;
}

.keyboard {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	gap: 6px;
}

.key_item {
	width: calc(33.33% - 4px);
	height: 52px;
	background: #fff;
	border-radius: 6px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	transition: all 0.2s;

	&:active {
		background: #e8e8e8;
		transform: scale(0.98);
	}

	.key_inner {
		font-size: 22px;
		font-weight: 600;
		color: #333;
		line-height: 1.2;
	}

	.key_letter {
		font-size: 10px;
		color: #999;
		text-transform: uppercase;
	}

	&.cancel {
		background: #e8e8e8;

		.key_inner {
			font-size: 14px;
			font-weight: 500;
		}
	}

	&.delete {
		background: #e8e8e8;

		.key_inner {
			font-size: 14px;
			font-weight: 500;
			color: #ff5252;
		}
	}
}

/* 设置密码遮罩 */
.setpwd_mask {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 100;
}

.setpwd_box {
	background: #fff;
	border-radius: 16px;
	padding: 30px 25px;
	width: 80%;
	max-width: 320px;
	text-align: center;

	.setpwd_title {
		font-size: 16px;
		color: #333;
		font-weight: 600;
		margin-bottom: 25px;
		line-height: 1.5;
	}

	.setpwd_btn {
		width: 100%;
		height: 44px;
		line-height: 44px;
		background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
		color: #fff;
		font-size: 15px;
		font-weight: 600;
		border-radius: 22px;
		cursor: pointer;
	}
}

/* 输入框去除数字箭头 */
[type="number"] {
	appearance: none;
	-webkit-appearance: none;

	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
}
</style>
